import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface WallManagerState {
  drawing: boolean;
  ctx: CanvasRenderingContext2D | null;
  size: {
    height: number;
    width: number;
  };
  initialized: boolean;
  error: string | null;
}

const initialState: WallManagerState = {
  drawing: false,
  ctx: null,
  size: {
    height: 0,
    width: 0,
  },
  initialized: false,
  error: null,
};

const wallManagerSlice = createSlice({
  name: 'wallManager',
  initialState,
  reducers: {
    setDrawing: (state, action: PayloadAction<boolean>) => {
      state.drawing = action.payload;
    },
    
    setContext: (state, action: PayloadAction<CanvasRenderingContext2D | null>) => {
      state.ctx = action.payload as any;
    },
    
    setSize: (state, action: PayloadAction<{ height: number; width: number }>) => {
      state.size = action.payload;
    },
    
    setInitialized: (state, action: PayloadAction<boolean>) => {
      state.initialized = action.payload;
    },

    setRenderError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

// Selectors
export const selectDrawing = (state: { wallManager: WallManagerState }) => state.wallManager.drawing;
export const selectContext = (state: { wallManager: WallManagerState }) => state.wallManager.ctx;
export const selectSize = (state: { wallManager: WallManagerState }) => state.wallManager.size;
export const selectInitialized = (state: { wallManager: WallManagerState }) => state.wallManager.initialized;
export const selectRenderError = (state: { wallManager: WallManagerState }) => state.wallManager.error;

export const { setDrawing, setContext, setSize, setInitialized, setRenderError } = wallManagerSlice.actions;

export default wallManagerSlice.reducer;